// Backend rule: no section flag = every section, any flag = only the flagged ones
export function getRequestProfileTabCountersParams(sections) {
  return Object.fromEntries(sections.map(section => [section, true]))
}
